@if (isAvailable) {
  <div
    [class.active]="isActive"
    [class.with-label]="label"
    [class.with-counter]="counter !== undefined"
    [class.with-icon]="iconName"
    class="button-container"
  >
    @if (type === 'view-switcher') {
      @if (isUnread) {
        <rt-dot color="unread" margin-right-small-xx />
      }
      @if (iconName) {
        <div class="icon-container">
          <rt-icon [name]="iconName" [size]="'small'" />
        </div>
      }
      @if (label) {
        <div class="label-container">
          {{ label }}
        </div>
      }
      @if (counter !== undefined && counter !== null) {
        <rt-badge color="counter-light" [text]="counter" />
      }
    }
    @if (type === 'multilang-switcher') {
      <div class="multilang-container">
        <ng-container>
          <div class="text">
            {{ language.name }}
            @if (language.isDefault || language.primary) {
              <span> ({{ bracketLabel }})</span>
            }
          </div>
          @if (loadingLanguageCode === language.code) {
            <div layout-centered class="spinner-wrap">
              <rt-spinner variant="small" />
            </div>
          }
          @if (!language.isDefault && loadingLanguageCode !== language.code) {
            <rt-circular-progress-indicator
              [percent]="getTranslationProgress(language.translationFieldsCount)"
              [rtTooltip]="getTooltipMessage(language.translationFieldsCount)"
              margin-left-small-x
            />
          }
        </ng-container>
      </div>
    }
  </div>
}
